"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendSms = sendSms;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _queue = require("../types/api-models/api/smsvalidation/queue");
const _excluded = ["subdomain"];
function sendSms(httpApi, parameters) {
  const {
      subdomain
    } = parameters,
    restParameters = (0, _objectWithoutProperties2.default)(parameters, _excluded);
  return httpApi.fetch((0, _queue.createSmsValidationQueueModel)({
    parameters: restParameters
  }), {
    subdomain,
    bodyAsEncodeString: true,
    requestConfig: {
      headers: [['Content-Type', 'application/x-www-form-urlencoded']]
    }
  });
}